// 레코드 항목이 복호화 대상인지 판단하는 순수 헬퍼.
// content 가 빈 문자열('')이면 제외한다 — 빈 값을 복호화하면 forge AES-CBC 가
// IV 추출 시 'Invalid IV length; got 0 bytes' 를 던지기 때문(선택 입력 빈 암호 필드).
// 따라서 null/undefined 뿐 아니라 빈 문자열도 건너뛰도록 truthy 체크한다.
// (RecordWrapper.getData / detail.getData 공통 — 무거운 import 없이 node 환경 단위 테스트 가능하도록 분리)
export const shouldDecryptItem = (item) =>
  item != null && item.encrypt === true && item.type !== 'file' && Boolean(item.content)

export default shouldDecryptItem
